import config from "./index";

// Type assertion for config to allow optional Cognito properties
const typedConfig = config as any;

export default {
  Auth: {
    Cognito: {
      region: typedConfig.AWS_REGION || "us-east-1",
      userPoolId: typedConfig.COGNITO_USER_POOL_ID || "",
      userPoolClientId: typedConfig.COGNITO_USER_POOL_WEB_CLIENT_ID || "",
      identityPoolId: typedConfig.COGNITO_IDENTITY_POOL_ID || "",
      allowGuestAccess: false,
      loginWith: {
        oauth: {
          domain: typedConfig.COGNITO_OAUTH_DOMAIN || "",
          scopes: ["email", "openid", "profile"],
          redirectSignIn: [
            typedConfig.OAUTH_REDIRECT_SIGNIN ||
              (typeof window !== "undefined"
                ? window.location.origin + "/auth/callback"
                : "")
          ],
          redirectSignOut: [
            typedConfig.OAUTH_REDIRECT_SIGNOUT ||
              (typeof window !== "undefined"
                ? window.location.origin + "/login"
                : "")
          ],
          responseType: "code" as const
        }
      }
    }
  }
};
